import {ReportOverviewComponent} from './report-overview.component';
import {ReportFormComponent} from './report-form.component';
import {NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {dynamicStateConfigFn, Ng2DynamicStateDeclaration} from '@ngx-ivengi/locale';

export let CHILD_STATES: Ng2DynamicStateDeclaration[] = [
  {
    name: 'management.report',
    component: ReportOverviewComponent,
    future: true,
    data: {
      pageTitle: 'states.report.pageTitle',
      scopes: ['management:read']
    }
  },
  {
    name: 'management.report.add',
    component: ReportFormComponent,
    future: true,
    data: {
      pageTitle: 'states.report.add.pageTitle',
      scopes: ['management:create']
    }
  },
  {
    name: 'management.report.edit',
    component: ReportFormComponent,
    future: true,
    data: {
      pageTitle: 'states.report.edit.pageTitle',
      scopes: ['management:update']
    }
  }
];

@NgModule({
  imports: [
    UIRouterModule.forChild({
      states: CHILD_STATES,
      config: dynamicStateConfigFn
    }),
    TranslateModule
  ],
  exports: [UIRouterModule]
})
export class ReportRoutingModule {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/report/report.routes.ts